$w.onReady(function () {

$w('#seasononebutton').onClick(() => {
		$w('#seasonone').expand();
        $w('#seasontwo').collapse();
        $w('#seasonthree').collapse();
        $w('#seasonfour').collapse();
        $w('#seasonfive').collapse();
    });
    
$w('#seasontwobutton').onClick(() => {
		$w('#seasontwo').expand();
        $w('#seasonone').collapse();
        $w('#seasonthree').collapse();
        $w('#seasonfour').collapse();
        $w('#seasonfive').collapse();
    });
   
$w('#seasonthreebutton').onClick(() => {
		$w('#seasonthree').expand();
        $w('#seasonone').collapse();
        $w('#seasontwo').collapse();
        $w('#seasonfour').collapse();
        $w('#seasonfive').collapse();
    });

$w('#seasonfourbutton').onClick(() => {
		$w('#seasonfour').expand();
        $w('#seasonone').collapse();
        $w('#seasontwo').collapse();
        $w('#seasonthree').collapse();
        $w('#seasonfive').collapse();
    });

$w('#seasonfivebutton').onClick(() => {
		$w('#seasonfive').expand();
        $w('#seasonone').collapse();
        $w('#seasontwo').collapse();
        $w('#seasonthree').collapse();
        $w('#seasonfour').collapse();
    });
});